import { FastlyImage } from '@components/common/image'
import SectionDivider from '@components/profile/teacher/section-divider'
import { PARTNERS_IMAGE_PATH } from '@lib/constants/geo-lp'
import React from 'react'

const Heading = ({ children }: { children: React.ReactNode }) => (
  <h3 className="text-base font-600 text-grey-800 mb-5 text-center">
    {children}
  </h3>
)

const LogoCell = ({
  src,
  alt,
  width,
  height,
}: {
  src: string
  alt: string
  width: number
  height: number
}) => (
  <div className="flex items-center justify-center">
    <FastlyImage src={src} alt={alt} width={width} height={height} />
  </div>
)

const BuiltByAlumniFooter = () => (
  <>
    <SectionDivider />
    <section className="p-5 lg:p-10">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div>
          <Heading>Built by alumni of</Heading>
          <div className="grid grid-cols-2 gap-y-4 items-center">
            <LogoCell
              src={`${PARTNERS_IMAGE_PATH}/google.png`}
              alt="Google"
              width={85}
              height={28}
            />
            <LogoCell
              src={`${PARTNERS_IMAGE_PATH}/amazon.png`}
              alt="Amazon"
              width={95}
              height={28}
            />
          </div>
        </div>

        <div>
          <Heading>Backed by</Heading>
          <div className="grid grid-cols-2 gap-y-4 items-center">
            <LogoCell
              src={`${PARTNERS_IMAGE_PATH}/ycombinator.png`}
              alt="Y Combinator"
              width={130}
              height={28}
            />
            <LogoCell
              src={`${PARTNERS_IMAGE_PATH}/rebright.png`}
              alt="Rebright Partners"
              width={120}
              height={28}
            />
          </div>
        </div>

        <div>
          <Heading>Accredited by</Heading>
          <div className="flex items-center justify-center">
            <FastlyImage
              src={`${PARTNERS_IMAGE_PATH}/stem-logo.png`}
              alt="STEM accredited educational experience"
              width={130}
              height={60}
            />
          </div>
        </div>
      </div>
    </section>
  </>
)

export default React.memo(BuiltByAlumniFooter)
